/**
 * App — Configuración de rutas principales de la SPA.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { Dashboard } from '@/pages/personal/Dashboard';
import { PersonalCalendar } from '@/pages/personal/PersonalCalendar';
import { Finances } from '@/pages/personal/Finances';
import { TimeTracking } from '@/pages/personal/TimeTracking';
import { ClientsList } from '@/pages/clients/ClientsList';
import { ClientDetail } from '@/pages/clients/ClientDetail';
import { AIAssistant } from '@/pages/ai/AIAssistant';
import { AuthCallback } from '@/pages/auth/AuthCallback';
import { MetaCallback } from '@/pages/auth/MetaCallback';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { LoginPage } from '@/pages/auth/LoginPage';
import { PackagesPage } from '@/pages/personal/PackagesPage';

export function App() {
  const { isAuthenticated, isVerifying, verifySession } = useAuthStore();

  useEffect(() => {
    verifySession();
  }, []);

  return (
    <Routes>
      {/* Callbacks de autenticación OAuth */}
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/meta/callback" element={<MetaCallback />} />

      {/* Si no está autenticado */}
      {!isAuthenticated ? (
        <Route
          path="*"
          element={
            isVerifying ? (
              <div className="min-h-screen bg-slate-900 flex items-center justify-center">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-10 h-10 border-4 border-violet-500 border-t-transparent rounded-full animate-spin" />
                  <p className="text-slate-400 text-sm font-medium">Verificando sesión...</p>
                </div>
              </div>
            ) : (
              <LoginPage />
            )
          }
        />
      ) : (
        <Route path="/" element={<AppLayout />}>
          {/* Redirección raíz a personal */}
          <Route index element={<Navigate to="/personal" replace />} />

          {/* Sección Personal */}
          <Route path="personal" element={<Dashboard />} />
          <Route path="personal/paquetes" element={<PackagesPage />} />
          <Route path="personal/calendario" element={<PersonalCalendar />} />
          <Route path="personal/finanzas" element={<Finances />} />
          <Route path="personal/tiempo" element={<TimeTracking />} />
          <Route path="paquetes" element={<Navigate to="/personal/paquetes" replace />} />

          {/* Sección Clientes */}
          <Route path="clientes" element={<ClientsList />} />
          <Route path="clientes/:id" element={<ClientDetail />} />

          {/* Sección Herramientas IA */}
          <Route path="ai" element={<AIAssistant />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/personal" replace />} />
        </Route>
      )}
    </Routes>
  );
}

export default App;
